export const environment = {
        production: false,
        apiUrl: 'https://api.iccons.com.au/api/supplierportal',
        authUrl: 'https://api.iccons.com.au/api/supplierportal/auth'
};
